import english from './en';
import dutch from './nl';
import french from './fr';
export const messages = {
    en: english,
    nl: dutch,
    fr: french,
};
